var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2348_4057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.386368 8.89228C0.385947 10.4046 0.784095 11.8813 1.54117 13.1829L0.313965 17.63L4.89943 16.4367C6.1677 17.122 7.58872 17.4811 9.03275 17.4811H9.03655C13.8036 17.4811 17.6841 13.6312 17.6861 8.89905C17.687 6.606 16.7881 4.44977 15.1549 2.82754C13.5219 1.20545 11.3502 0.311654 9.0362 0.310608C4.2686 0.310608 0.388407 4.16038 0.386439 8.89228",
    fill: "url(#paint0_linear_2348_4057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0774125 8.88949C0.0769205 10.4563 0.489339 11.9858 1.27341 13.334L0.00219727 17.9405L4.75208 16.7044C6.06082 17.4126 7.53434 17.786 9.03372 17.7866H9.03759C13.9756 17.7866 17.9955 13.7981 17.9976 8.8966C17.9985 6.52116 17.0672 4.28742 15.3756 2.60707C13.6839 0.92693 11.4344 0.000976744 9.03759 0C4.09869 0 0.0793808 3.98791 0.0774125 8.88949ZM2.90607 13.1018L2.72872 12.8223C1.98317 11.6458 1.58966 10.2862 1.59022 8.89005C1.59184 4.81598 4.93252 1.5014 9.0404 1.5014C11.0297 1.50223 12.8993 2.27191 14.3055 3.66837C15.7116 5.06498 16.4853 6.92149 16.4848 8.89605C16.483 12.9701 13.1422 16.2851 9.03759 16.2851H9.03464C7.69813 16.2844 6.38734 15.9282 5.24421 15.255L4.97217 15.0949L2.15349 15.8283L2.90607 13.1017V13.1018Z",
    fill: "url(#paint1_linear_2348_4057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79826 5.1731C6.63054 4.80312 6.45403 4.79565 6.29453 4.78917C6.16392 4.78358 6.01462 4.784 5.86545 4.784C5.71614 4.784 5.47356 4.83975 5.26851 5.06196C5.06325 5.28438 4.48486 5.82186 4.48486 6.91505C4.48486 8.00831 5.28714 9.06479 5.39898 9.21319C5.51095 9.36131 6.94778 11.6765 9.22335 12.5671C11.1146 13.3073 11.4994 13.1601 11.9099 13.123C12.3204 13.086 13.2345 12.5856 13.421 12.0667C13.6076 11.548 13.6076 11.1033 13.5517 11.0103C13.4957 10.9177 13.3464 10.8621 13.1225 10.7511C12.8986 10.6399 11.7979 10.1024 11.5927 10.0282C11.3874 9.95412 11.2382 9.91714 11.0889 10.1396C10.9396 10.3618 10.5109 10.8621 10.3802 11.0103C10.2497 11.1589 10.119 11.1774 9.89516 11.0662C9.67113 10.9547 8.95012 10.7204 8.0947 9.96347C7.42915 9.37449 6.97983 8.64717 6.84922 8.42468C6.71862 8.20254 6.83524 8.08212 6.9475 7.9714C7.04809 7.87184 7.17145 7.71193 7.2835 7.58224C7.39513 7.45247 7.43239 7.35989 7.50704 7.2117C7.58176 7.06338 7.54437 6.93361 7.48848 6.82247C7.43239 6.71133 6.99733 5.61242 6.79826 5.1731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2348_4057",
    x1: 868.92,
    y1: 1732.25,
    x2: 868.92,
    y2: 0.310608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2348_4057",
    x1: 899.774,
    y1: 1794.05,
    x2: 899.774,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2348_4057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.389e96bc9cb6ae2d2c1f8f2bc7e5ea8c.svg";
export { ForwardRef as ReactComponent };